// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3WwQq","header":"PatientBlock_header__KQspr","label":"PatientBlock_label__3hD-T","option":"PatientBlock_option__3K-uv"};